import type { IApiLivestreamResponse } from '@/services';
import type { ILivestreamData } from '@/entities';

export const mapApiLivestream = (data: Readonly<IApiLivestreamResponse>): ILivestreamData => {
  return {
    id: data.id,
    description: data.description,
    header: data.header,
    imageUrl: data.imageUrl,
    dateTime: new Date(data.dateTime),
    source: data.source,
    sourceUrl: data.sourceUrl,
    isChatEnabled: data.isChatEnabled
  };
};
